import { ConfigService } from '../../config/config.service';
var Ng1ModalService = /** @class */ (function () {
    function Ng1ModalService(configService) {
        this.configService = configService;
        this.modalService = configService.getValue('ModalService');
    }
    Object.defineProperty(Ng1ModalService.prototype, "lazyModalService", {
        get: function () {
            if (!this.modalService) {
                this.modalService = this.configService.getValue('ModalService');
            }
            return this.modalService;
        },
        enumerable: true,
        configurable: true
    });
    return Ng1ModalService;
}());
export { Ng1ModalService };
